import React, { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import OnboardingPage from "../../pages/onboarding-page/OnboardingPage";
import TextEditorPage from "../../pages/text-editor-page/TextEditorPage";
import StartPage from "../../pages/start-page/StartPage";
import PrivacyPolicy from "../../pages/privacy-page/PrivacyPage";
import TermsOfService from "../../pages/terms-of-use-page/TermsOfUsePage";
import EulaPage from "../../pages/eula-page/EulaPage";

const RoutesConfig: FC = () => {
    const location = useLocation();

    return (
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<StartPage />} />
                <Route
                    path="/onboarding"
                    element={
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.2}}
                            style={{width:'100%'}}
                        >
                            <OnboardingPage />
                        </motion.div>
                    }
                />
                <Route path="/text_editor/:projectId/" element={<TextEditorPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermsOfService />} />
                <Route path="/eula" element={<EulaPage />} />

            </Routes>
        </AnimatePresence>
    );
};

export default RoutesConfig;
